import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isPaymentMethod?: boolean;
}> = ({ isPaymentMethod }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1.5),
  background: isPaymentMethod ? 'transparent' : (p) => p.palette.grey[200],
  padding: isPaymentMethod ? (p) => p.spacing(0) : (p) => p.spacing(1.5),
  borderRadius: isPaymentMethod ? (p) => p.spacing(0) : (p) => p.spacing(0.5),
});
